enum CampaignGoalType {
  MONETARY = 'monetary',
  IN_KIND = 'in_kind',
}

export default CampaignGoalType;
